// src/locales/en/orders.js
export const orders = {
    newOrder: "New Order",
    orderNumber: "Order #{{number}}",
    customer: "Customer",
    amount: "Amount",
    date: "Date",
    status: "Status",
    pending: "Pending",
    processing: "Processing",
    shipped: "Shipped",
    delivered: "Delivered",
    cancelled: "Cancelled",
    returned: "Returned"
}